export default __webpack_public_path__ + "148ede58025f99b60ff5983160f349e9.png";